// extracted by mini-css-extract-plugin
export default {"wrapper":"RefreshBtn_wrapper__QiGqZ","icon":"RefreshBtn_icon__Swebd"};